/**
 * Іконки панелі дій запису — ті самі контури, що в прототипі v4 (Groundwork.dc.html, панель «Record actions»): лінія 1.8 з круглими
 * кінцями, сітка 24×24. Ключ → набір фігур SVG (шлях `d`, коло `c:x,y,r`, прямокутник `r:x,y,w,h,rx`).
 */
export const RECORD_ICONS: Record<string, readonly string[]> = {
  edit: ['M12 20h9', 'M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z'],
  check: ['M20 6 9 17l-5-5'],
  trash: ['M3 6h18', 'M8 6V4h8v2', 'M19 6l-1 14H6L5 6', 'M10 11v6M14 11v6'],
  star: ['m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z'],
  assign: ['c:10,8,4', 'M2 21a8 8 0 0 1 12.5-6.6', 'M19 15v6', 'M16 18h6'],
  copy: ['r:9,9,11,11,2', 'M5 15V5a2 2 0 0 1 2-2h8'],
  link: ['M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7', 'M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7'],
  print: ['M7 9V4h10v5', 'r:4,9,16,8,2', 'M8 17v3h8v-3'],
  download: ['M12 3v12', 'm7 10 5 5 5-5', 'M5 21h14'],
  graph: ['c:12,12,3', 'c:4.5,5,2', 'c:19.5,5,2', 'c:19.5,19,2', 'c:4.5,19,2', 'M6.2 6.3 9.8 9.9M17.8 6.3l-3.6 3.6M17.8 17.7l-3.6-3.6M6.2 17.7l3.6-3.6'],
  comment: ['M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z'],
  clip: ['M21.4 11.1 12.2 20.3a6 6 0 0 1-8.5-8.5l9.2-9.2a4 4 0 0 1 5.7 5.7l-9.2 9.2a2 2 0 0 1-2.8-2.8l8.5-8.5'],
  bulb: ['M9 18h6', 'M10 22h4', 'M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z'],
  sparkles: ['M12 3l1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9z', 'M19 15l.8 1.9L21.7 18l-1.9.8L19 20.7l-.8-1.9L16.3 18l1.9-1.1z'],
  upload: ['M12 16V4', 'm7 9 5-5 5 5', 'M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3'],
};
